export default "__VITE_PUBLIC_ASSET__96adbfeb__"